import $ from 'jquery';
import '../class/wp-jquery.easy-autocomplete';
import '../class/jquery-cookies';
import { Fancybox } from "@fancyapps/ui";

const eventActions = () => {

	$(document)
		// presmerovani na detail v pruvodci sluzeb
		.on('click', 'tr.detail-click', function(e) {

			if ( !$(e.target).hasClass('js-disable-table-link') ) {
				location.href = $(this).data('detail-url');
			}

		})
		// smazani addonu
		.on('click', '.js-remove', function(e) {
			e.preventDefault();

			var $this = $(this),
				$el = $this.closest('.b-table-bag__table-items'),
				$select = $el.find('select');

			$el.removeClass('is-selected');
			$select.val($select.find('option').first().val());
			$el.find('.pepa').html('');

			// ajax logika
			$.ajax({
				url: wc_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'get_basket' ),
				type: 'post',
				dataType: 'HTML',
				data: {
					action: 'woocommerce_delete_addon',
					product_id: $(this).data('product-id'),
					key: $(this).data('key'),
					addon: $(this).data('addon'),
					step: active_cart_step
				},
				beforeSend: function(){
					cart_loading();
				}
			})
			.done(function(response){
				$.ajax({
					url: wc_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'get_basket' ),
					type: 'post',
					dataType: 'HTML',
					data: {
						step: active_cart_step
					}
				}).done( function(response) {
					cart_reloaded(false, response);
				});
			});
		})
		// nastaveni URL pro pridani do kosiku
		.on( 'click', '.do-add-to-cart', function(e){
			var id = $(this).data('product_id');

			location.href = location.pathname + '?' + insertParam( 'add-to-cart', id );

			e.preventDefault();
		})
		// zmena addonu
		.on('change', '.select__shop', function(e) {
			var $this = $(this),
				$option = $this.find('option:selected'),
				$el = $this.closest('.b-table-bag__table-items');

			if ($option.attr('data-price') && $option.attr('data-count') && $option.attr('data-total-price')) {
				$el.addClass('is-selected');
				$el.find('.b-table-bag__price').html($option.attr('data-price'));
				$el.find('.b-table-bag__num').html($option.attr('data-count'));
				$el.find('.b-table-bag__total > span').html($option.attr('data-total-price'));
				$el.find('.pepa').html($option.html());
			}
			else {
				$el.removeClass('is-selected');
				$el.find('.pepa').html('');
			}

			// ajax logika
			$.ajax({
				url: wc_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'get_basket' ),
				type: 'post',
				dataType: 'HTML',
				data: {
					action: 'woocommerce_update_addon',
					product_id: $(this).data('product-id'),
					key: $(this).data('key'),
					value: $(this).val(),
					addon: $(this).data('addon'),
					step: active_cart_step
				},
				beforeSend: function(){
					cart_loading();
				}
			})
			.done(function(response){
				$.ajax({
					url: wc_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'get_basket' ),
					type: 'post',
					dataType: 'HTML',
					data: {
						step: active_cart_step
					}
				}).done( function(response) {
					cart_reloaded(false, response);
				});
			});
		})
		// zmena poctu kusu
		.on('change', 'input[name="cart-qty"]', function(e) {
			$.ajax({
				url: wc_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'get_basket' ),
				type: 'post',
				dataType: 'HTML',
				data: {
					action: 'woocommerce_update_qty',
					key: $(this).data('key'),
					qty: $(this).val(),
					step: active_cart_step
				},
				beforeSend: function(){
					cart_loading();
				}
			})
			.done(function(response){
				cart_reloaded(false, response);
				cart_count();
			});
		})
		// odebrani z kosiku
		.on('click', '.cart-remove-product', function(e) {
			$.ajax({
				url: wc_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'get_basket' ),
				type: 'post',
				dataType: 'HTML',
				data: {
					action: 'woocommerce_remove',
					key: $(this).data('key'),
					step: active_cart_step
				},
				beforeSend: function(){
					cart_loading();
				}
			})
			.done(function(response){
				if ( $('.cart_item').length == 0 ) {
					location.reload();
				} else {
					cart_reloaded(false, response);
					cart_count();
				}
			});
		})
		// odebrani z MINI kosiku
		.on('click', '.mini-cart-remove-product', function(e) {
			var remove_qty = parseInt( $(this).data('qty') );

			$.ajax({
				url: skwp.ajax_url,
				type: 'post',
				dataType: 'HTML',
				data: {
					action: 'woocommerce_remove',
					key: $(this).data('key')
				},
				beforeSend: function() {
					$('.b-bag').html( '<img src="' + skwp.loading_url + '" alt="' + skwp.loading_text + '" width="50" height="50">' );
				}
			})
			.done(function(response){
				$.ajax({
					url: skwp.ajax_url,
					type: 'post',
					data: {
						action: 'woocommerce_mini_cart'
					}
				})
				.done(function(response){
					$('.b-bag').html(response);

					var count = parseInt( $('.m-header__bag-num').text() ) - remove_qty;

					if ( count > 0 ) {
						$('.m-header__bag-num').text( count );
					} else {
						$('.m-header__bag-num').hide();
					}
				});
			});
			e.preventDefault();
		})
		// pridani slevoveho kuponu
		.on('click', '.cart-coupon', function(e) {
			var coupon = $('input[name="sale_coupon"]').val();

			if ( coupon != '' ) {
				$.ajax({
					url: wc_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'get_basket' ),
					type: 'post',
					dataType: 'HTML',
					data: {
						action: 'woocommerce_add_coupon',
						coupon: coupon,
						step: active_cart_step
					},
					beforeSend: function(){
						cart_loading();
					}
				})
				.done(function(response){
					cart_reloaded(true, response);
				});
			}

			e.preventDefault();
		})
		// odebrani slevoveho kuponu
		.on('click', '.remove-cart-coupon', function(e) {
			$.ajax({
				url: wc_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'get_basket' ),
				type: 'post',
				dataType: 'HTML',
				data: {
					action: 'woocommerce_delete_coupon',
					step: active_cart_step
				},
				beforeSend: function(){
					cart_loading();
				}
			})
			.done(function(response){
				cart_reloaded(false, response);
			});

			e.preventDefault();
		})
		// pridani cross-sell produktu do kosiku
		.on('change', '.checkbox__service', function(e) {
			$.ajax({
				url: wc_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'get_basket' ),
				type: 'post',
				dataType: 'HTML',
				data: {
					action: 'woocommerce_cross_sell',
					product_id: $(this).data('product-id'),
					parent_key: $(this).data('parent-key'),
					key: $(this).data('key'),
					type: $(this).prop('checked'),
					step: active_cart_step
				},
				beforeSend: function(){
					cart_loading();
				}
			})
			.done(function(response){
				cart_reloaded(false, response);
				cart_count();
			});

			e.preventDefault();
		})
		// cross sell produkt detail
		.on('click', '.cross-sell-detail', function(e) {
			$.ajax({
				url: skwp.ajax_url,
				type: 'post',
				dataType: 'HTML',
				data: {
					action: 'woocommerce_cross_sell_detail',
					product_id: $(this).data('product-id')
				},
				beforeSend: function(){
					$('#modal-detail').html( '<img src="' + skwp.loading_url + '" alt="' + skwp.loading_text + '" width="50" height="50">' );
				}
			})
			.done(function(response){
				$('#modal-detail').html(response);
				$(window).trigger('resize');
			});

			e.preventDefault();
		})
		// pridani produktu do kosiku a nasledne presmerovani na kosik
		.on('click', 'a.button-quick-order', function(e) {
			var span = $(this).find('span');

			$.ajax({
				url: skwp.ajax_url,
				type: 'post',
				data: {
					action: 'woocommerce_add_to_cart',
					product_id: $(this).data('product-id')
				},
				beforeSend: function(){
					span.text( skwp.ordering_text );
				}
			})
			.done(function(response){
				location.href = skwp.cart_url;
			});

			e.preventDefault();
		})
		// nacteni dat z ARES
		.on('click', '.cart-fill-ares', function(e) {
			$.ajax({
				url: skwp.ajax_url,
				type: 'post',
				data: {
					action: 'woocommerce_ares',
					ic: $('#billing_company_ic').val()
				},
				beforeSend: function(){
					cart_loading();
				}
			})
			.done(function(response){
				if ( response.status ) {
					$( '#billing_company' ).val( response.company );
					$( '#billing_address_1' ).val( response.street + ' ' + response.street_number ),
					$( '#billing_city' ).val( response.city );
					$( '#billing_postcode' ).val( response.zip );
					$( '#billing_company_dic' ).val( response.dic );
				} else {
					cart_error( status.message );
				}

				$('.b-loading').removeClass('is-active');
			});

			e.preventDefault();
		})
		// prihlaseni v kosiku
		.on('submit', '.modal-login-cart', function(e) {
			$.ajax({
				url: wc_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'get_basket' ),
				type: 'post',
				data: {
					action: 'woocommerce_login',
					email: $('#modal_login_email').val(),
					password: $('#modal_login_password').val()
				},
				beforeSend: function(){
					cart_loading();
				}
			})
			.done(function(response){
				if ( response.status ) {
					Fancybox.close();
					cart_reloaded(false, response);
				} else {
					$( '#modal-login-error').removeClass( 'js-hide' ).show().html( response.status_message );
					$('.b-loading').removeClass('is-active');
				}
			});

			e.preventDefault();
		})
		// zmena kroku v kosiku
		.on('click', '.change-step', function(e) {
			var goto_step = $(this).data('goto-step');

			if ( goto_step == 4 ) {
				cart_save_address_and_finish();
			} else {
				change_step(goto_step);
			}

			e.preventDefault();
		})
		// zmena metody dopravy
		.on('change', '.shipping_method_id', function(e) {
			var shipping_method_chosen = $(this).val();

			if ( typeof shipping_method_chosen == 'undefined' ) {
				return;
			}

			jQuery.ajax( {
				type: 'post',
				url: wc_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'update_shipping' ),
				data: {
					shipping_method: [ shipping_method_chosen ],
					step: 2
				},
				beforeSend: function(){
					cart_loading();
				},
			}).done( function( response ) {
				$('.woocommerce').html(response.cart);
				$('#payments').html(response.payments);
				$('.b-loading').removeClass('is-active');
				posta_autocomplete();
			} );
		})
		// zmena metody platby
		.on('change', '.pay_method', function(e) {
			var payment_method_chosen = $(this).val();

			if ( typeof payment_method_chosen == 'undefined' ) {
				return;
			}

			jQuery.ajax( {
				type: 'post',
				url: wc_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'update_payment' ),
				data: {
					payment: payment_method_chosen,
					step: 2
				},
				beforeSend: function() {
					cart_loading();
				}
			}).done( function( response ) {
				$('.woocommerce').html(response.cart);
				$('#payments').html(response.payments);
				$('.b-loading').removeClass('is-active');
				posta_autocomplete();
			} );
		})
		// removing/adding tr
		.on('click', '.js-cancel', function(e) {
			e.preventDefault();

			var $this = $(this),
				$tr = $this.closest('tr'),
				$next = $tr.next();

				$tr.fadeOut(300, function() {
					$tr.remove();
				});

				if ($next.hasClass('b-table-bag__extend')) {
					$next.fadeOut(300, function() {
						$next.remove();
					});
				}
		})
		// checkboxy
		.on('change', '.checkbox__service', function(e) {

			var $this = $(this),
				$el = $this.closest('.b-table-bag__table-items--extend');

			if ( $this.is(':checked') ) {
				$el.addClass('is-active');
			}

			else {
				$el.removeClass('is-active');
			}
		})
		// zobrazit a nacist obsah kosiku (.b-bag) v hlavicce
		.on('click', '.m-header__item--spec > .m-header__link', function(e) {

			// is-tablet-min
			if ( window.innerWidth >= 768 ) {

				e.preventDefault();

				$('.b-bag').toggleClass('is-active');

				if ( $('.b-bag').hasClass('is-active') ) {
					$.ajax({
						url: skwp.ajax_url,
						type: 'post',
						data: {
							action: 'woocommerce_mini_cart'
						},
						beforeSend: function(){
							$('.b-bag').html( '<img src="' + skwp.loading_url + '" alt="' + skwp.loading_text + '" width="50" height="50">' );
						}
					})
					.done(function(response){
						$('.b-bag').html(response);
					});
				}

			}
		})
		// f-filter
		.on('click', '.btn__filter', function(e) {
			e.preventDefault();

			$('body').toggleClass('show-filter');
		})
		.on('click', '.f-filter__close', function(e) {
			e.preventDefault();

			$('body').removeClass('show-filter');
		})
		// zmena zeme zobrazeni doprav
		.on('change', '#billing_country', function(e) {
			$.ajax({
				url: wc_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'get_basket' ),
				type: 'post',
				data: {
					action: 'woocommerce_change_country',
					country: $('#billing_country').val(),
					step: 2
				},
				beforeSend: function(){
					cart_loading();
				}
			})
			.done(function(response){
				cart_reloaded(false, response);
			});

			e.preventDefault();
		})
		// inp count
		.on('click', '.inp__count__tool', function(e) {
			e.preventDefault();

			var $this = $(this),
				$closest = $this.closest('.inp__count'),
				$inp = $closest.find('.inp__text');

			if ( ( $inp.val() * 1 > 1 && $this.hasClass('inp__count__tool--minus') ) || $this.hasClass('inp__count__tool--plus') ) {
				$inp.val( $inp.val() * 1 + $this.data('step') ).trigger('change');
				$(this).trigger( 'woocommerce-product-addons-update' );

				// prepocitani ceny
				/*
				-- prestalo fungovat, chybi accounting.js a nepodarilo se mi jej nalinkovat, tak zatim neresim (dan) --

				var product_price = ( parseInt( $('#product-addons-total').attr('data-price') ) + parseInt( jQuery('#product-addons-total').data('addons-price') ) ) * parseInt( $inp.val() );

				var formatted_price = accounting.formatMoney( product_price, {
					symbol 		: woocommerce_addons_params.currency_format_symbol,
					decimal 	: woocommerce_addons_params.currency_format_decimal_sep,
					thousand	: woocommerce_addons_params.currency_format_thousand_sep,
					precision 	: woocommerce_addons_params.currency_format_num_decimals,
					format		: woocommerce_addons_params.currency_format
				});

				$('.f-extend__price span').html( formatted_price );
				*/
			}
		})
		// tabs
		.on('click', '.b-tabs__link, .js-b-tabs__link', function(e){
			e.preventDefault();

			var $this = $(this),
				$closest = $this.closest('.b-tabs'),
				$links = $closest.find('.b-tabs__link, .js-b-tabs__link'),
				$tabs = $closest.find('.b-tabs__fragment'),
				$pager = $closest.find('.b-tabs__pager-item');

			if ( !$closest.hasClass('b-tabs--static') && !$this.hasClass('is-inactive') || e.isTrigger ) {
				$links.removeClass('is-active');
				$tabs.removeClass('is-active');

				$this.addClass('is-active');
				$tabs.filter( $this.attr('href') ).addClass('is-active');

				$pager.removeClass('is-active')
					.eq( $this.parent().index() ).addClass('is-active');

				if ( $this.hasClass('js-b-tabs__link') ) {
					$links.not($this).addClass('not-active');
					$this.removeClass('not-active');
				}
			}
		})
		.on('click', '.b-tabs__pager-item', function(e){
			e.preventDefault();

			var $this = $(this),
				$closest = $this.closest('.b-tabs'),
				$tabs = $closest.find('.b-tabs__item');

			if ( $this.hasClass('js-pager-disable') ) return;

			if ( !$closest.hasClass('b-tabs--static') ) {
				$tabs.eq( $this.index() ).find('.b-tabs__link').trigger('click');
			}
		})
		.on('click', '.b-tabs__prev', function(e){
			e.preventDefault();

			var $this = $(this),
				$closest = $this.closest('.b-tabs'),
				$tabs = $closest.find('.b-tabs__item'),
				$active = $closest.find('.b-tabs__link.is-active'),
				$linkItem = $active.closest('.b-tabs__item'),
				index = $linkItem.index();

			if ( $linkItem.is(':first-child') ) {
				index = $tabs.length-1;
			} else {
				index = index - 1;
			}

			$tabs.eq( index ).find('.b-tabs__link').trigger('click');
		})
		.on('click', '.b-tabs__next', function(e){
			e.preventDefault();

			var $this = $(this),
				$closest = $this.closest('.b-tabs'),
				$tabs = $closest.find('.b-tabs__item'),
				$active = $closest.find('.b-tabs__link.is-active'),
				$linkItem = $active.closest('.b-tabs__item'),
				index = $linkItem.index();

			if ( $linkItem.is(':last-child') ) {
				index = 0;
			} else {
				index = index + 1;
			}

			$tabs.eq( index ).find('.b-tabs__link').trigger('click');
		})
		.on('click', '.tab-trigger', function(e){
			var $this = $(this),
				$closest = $this.closest('.b-tabs'),
				$links = $closest.find('.b-tabs__link');

			if ( !$(this).is('input:checkbox') ) {
				e.preventDefault();
				$links.filter('[href="' + $this.data('target') + '"]').removeClass('is-inactive').trigger('click');
			}
		})
		.on('change', '.tab-trigger', function(){
			var $this = $(this),
				$closest = $this.closest('.b-tabs'),
				$links = $closest.find('.b-tabs__link');

			if ( $(this).is('input:checkbox') && $this.is(':checked') ) {
				$(this).parent().parent().parent().find('input').not($(this)).prop('checked', false);
				$links.filter('[href="' + $this.data('trigger') + '"]').removeClass('is-inactive').trigger('click');

				$this.closest('.b-tabs__fragment').find('.b-tabs__fragment__title').trigger('click');
				$closest.find('.b-tabs__fragment').filter( $this.data('trigger') ).find('.b-tabs__fragment__title').removeClass('is-inactive').trigger('click');
			}
		})
		.on('click', '.js-show-tab', function(e) {
			e.preventDefault();

			var $this = $(this),
				link = $this.attr('href'),
				$target = $(link),
				$tabs = $('.b-tabs'),
				$fragments = $tabs.find('.b-tabs__fragment'),
				$links = $tabs.find('.b-tabs__link');

			$fragments.removeClass('is-active');
			$links.removeClass('is-active');

			$target.addClass('is-active');
			$links
				.filter(function(){
					return $(this).attr('href') === link;
				})
				.addClass('is-active');

			$('html,body').animate({
				scrollTop: $tabs.offset().top
			}, 500);

		})
		// form steps
		.on('submit', '.f-steps', function(e){
			e.preventDefault();

			var $this = $(this),
				$closest = $this.closest('.b-tabs'),
				$links = $closest.find('.b-tabs__link');

			$.ajax({
				url: $this.attr('action'),
				data: $this.serialize()
			})
			.done(function(response){
				if ( $(response).hasClass('error') ){
					$closest.find( $this.data('target-error') ).append(response);
				}
				else {
					$links.filter('[href="' + $this.data('target') + '"]').trigger('click');
				}
			});

		})
		// inp-copy
		.on('change', '.inp-copy', function(e){
			e.preventDefault();

			var $this = $(this),
				$closest = $this.closest('.b-tabs'),
				$all = $closest.find('.inp-copy'),
				$target = $( $this.data('target') );

			$target.html('');

			$all.each(function(){
				if ( $(this).is(':checked') ) {
					$target.append('<p><span class="inp__item inp__item--checkbox">' + $(this).closest('.inp__item').html() + '</span></p>');
					$target.append('<input name="form_items[]" value="' + $(this).closest('.inp__item').find('input').attr('value') + '" type="hidden">');
				}
			});

		})
		// mobile menu
		.on('click', '.js-menu-open', function(e){
			e.preventDefault();

			var $header = $('.header');

			$header
				.toggleClass('show-menu')
				.removeClass('show-search');

		})
		// mobile submenu
		.on('click', '.js-submenu-open', function(e){
			e.preventDefault();

			var $this = $(this);
			var $li = $this.closest('li');

			$li
				.toggleClass('is-open');

		})
		// mobile footer
		.on('click', '.footer__title', function(e){
			e.preventDefault();

			$(this).closest('.footer__box').toggleClass('is-open');
			$(this).closest('.footer__shop').toggleClass('is-open');

		})
		// mobile tabs
		.on('click', '.b-tabs__fragment__title', function(e){
			e.preventDefault();

			var $this = $(this);

			if ( !$this.hasClass('is-inactive') ){
				$this.closest('.b-tabs__fragment').toggleClass('is-open');
			}

			// var $this = $(this),
			// 	$closest = $this.closest('.b-tabs'),
			// 	$closestTab = $this.closest('.b-tabs__fragment'),
			// 	$link = $closest.find('.b-tabs__link');

			// $link.find('[href="#'+$closestTab.attr('id')+'"]');

		})
		// opening/closing search
		.on('click', '.m-header__link--search', function(e){
			e.preventDefault();

			var $header = $('.header');

			$header.toggleClass('show-search')
				.removeClass('show-menu');

			if ( $header.hasClass('show-search') ) {
				$('.f-search .inp__text').focus();
			}
		})
		.on('click', '.f-search__back', function(e){
			e.preventDefault();

			$('.header').removeClass('show-search');
		})
		//closing search by escape
		.on('keydown', '.f-search .inp__text', function(e){
			if (e.which == 27) {
				e.preventDefault();
				var $header = $('.header');

				$header.removeClass('show-search');
			}
		})
		// opening/closing c-questions
		.on('click', '.c-questions__btn', function(e){
			e.preventDefault();

			var $this = $(this),
				$item = $this.closest('.c-questions__item'),
				$active = $item.parent().find('.c-questions__item.is-active'),
				$box = $item.find('.c-questions__hide');

			if (!$item.hasClass('is-active')) {
				$active.removeClass('is-active').find('.c-questions__hide').slideUp(300);
			}

			$item.toggleClass('is-active');
			$box.slideToggle(300);
		})
		// opening/closing b-showcontent
		.on('click', '.b-showcontent__link', function(e){
			e.preventDefault();

			var $this = $(this),
				$item = $this.closest('.b-showcontent'),
				$box = $item.find('.b-showcontent__hide');

			$item.toggleClass('is-active');
			$box.slideToggle(300);
		})
		// opening/closing f-filter
		.on('click', '.f-filter__title', function(e){
			e.preventDefault();

			var $this = $(this),
				$item = $this.closest('.f-filter__item'),
				$box = $item.find('.f-filter__hide');

			$this.toggleClass('is-active');
			$box.slideToggle(300);

			// otevrene filtry do cookies
			var cookie_key = 'filter-' + $('#main').data('category-id');

			if ( typeof $.cookie( cookie_key ) == 'undefined' ) {
				var filters = [];
			} else {
				var filters = JSON.parse( $.cookie( cookie_key ) );
			}

			var is_active = $this.hasClass('is-active' );

			if ( filters.indexOf( $this.data( 'filter-name' ) ) == -1 ) {
				if ( is_active ) {
					filters.push( $this.data( 'filter-name' ) );
				}
			} else {
				if ( !is_active ) {
					filters.splice( filters.indexOf( $this.data( 'filter-name' ) ), 1 );
				}
			}

			$.cookie( cookie_key, JSON.stringify( filters ), { expires: 1, path: '/' } );
		})
		//scroll top
		.on('click', '.footer__back', function(e){
			e.preventDefault();

			$('html, body').animate({scrollTop: '0px'}, 400);
		})
		// deleting text input
		.on('click', '.icon-svg--cross', function(e){
			e.preventDefault();

			$(this).next('.inp__text').val('');
		})
		// checkbox opening
		.on('change', '.checkbox__toggle', function(e) {
			var $this = $(this),
				$target = $( $this.data('target') );

			if ( e.isTrigger ) {
				if ( $this.is(':checked') ){
					$target.show();
				}
			}
			else {
				$target.slideToggle();
			}
		})
		// select opening
		.on('change', '.select__toggle', function() {
			var $this = $(this),
				$target = $this.find('option:selected').attr('data-target'),
				$targets = $this.find('option[data-target]');

			$targets.each(function() {
				if ($(this).attr('data-target') === $target) {
					$($target).slideDown();
				}
				else {
					$($(this).attr('data-target')).slideUp();
				}
			});
		})
		// radio opening
		.on('change', '.radio__toggle', function(e) {
			var $this = $(this),
				$all = $('input[name="' + $this.attr('name') + '"]'),
				$target = $( $this.data('target') );

			if ( e.isTrigger ) {
				if ( $this.is(':checked') ){
					$target.show();
				}
			}
			else {
				$all.each(function(){
					var $that = $(this);

					$( $that.data('target') ).slideUp();
				});

				$target.slideDown();
			}
		})
		// opening tables
		.on('click', '.b-table__btn', function(e) {
			e.preventDefault();

			var $this = $(this);

			if ($this.closest('tr').hasClass('is-open')) {
				$(this).closest('tr').removeClass('is-open');
			} else {
				$this.closest('tr').addClass('is-open');
			}

			// if ($this.closest('tr').hasClass('is-open')) {
			// 	$this.closest('tr').find('td:not(.b-table__btn)').slideUp(300, function() {
			// 		$(this).closest('tr').removeClass('is-open');
			// 	});
			// }
			// else {
			// 	$this.closest('table').find('tr.is-open td:not(.b-table__btn)').slideUp(300, function() {
			// 		$(this).closest('tr').removeClass('is-open');
			// 	});

			// 	$this.closest('tr').addClass('is-open').find('td:not(.b-table__btn)').slideDown(300);
			// }
		})
		// mac upgrade choose another model
		.on('click', '.mac-upgrade-reset', function(e) {
			e.preventDefault();

			$('.b-tabs__fragment').removeClass('is-active');
			$('#ajax-target').html('');
			$('.c-choose__inner').removeClass('is-active').removeClass('not-active');

			$('body, html').animate({
				scrollTop: $('#cenik').offset().top - 50
			}, 250);
		})
		.on('click', '.js-goto-cf7', function(e) {
			$('body, html').animate({
				scrollTop: $('#cf7-element').offset().top - 50
			}, 250);

			e.preventDefault();
		})
		// ajax link
		.on('click', '.link-ajax', function(e){
			e.preventDefault();

			var $this = $(this),
				$target = $( $this.data('target') ),
				post_id = $this.data('id');

			$.ajax({
				url: skwp.ajax_url,
				type: 'post',
				dataType: 'HTML',
				data: {
					action: 'upgrade_mac',
					post_id: post_id,
				},
				beforeSend: function(){
					$target.html('<img src="' + skwp.theme_url + '/static/img/bg/loading.gif" style="display:block; margin: 0 auto 50px;">');
				}
			})
			.done(function(response){
				$target.html(response).trigger('contentload');

				$target.find('a[href^="#form-"]').addClass('fancybox');
				$target.find('a[href^="#fancybox-"]').addClass('fancybox');

				// inicializace WPCF7
				$( 'div.wpcf7 > form' ).each( function() {
					var $form = $( this );

					wpcf7.init( $form[0] );

					$form.on( 'submit', function( event ) {
						if ( typeof window.FormData !== 'function' ) {
							return;
						}

						wpcf7.submit( $form[0] );
						event.preventDefault();
					} );
				});

				$('body, html').animate({
					scrollTop: $target.offset().top - 50
				}, 250);
			});
		})
		.on('click', '.b-form-steps input[type="radio"]', function(e){
			var $input = $(this);
			var $steps = $input.closest('.b-form-steps');
			var step = $input.data('step');

			$steps
				.removeClass('active-1')
				.removeClass('active-2')
				.removeClass('active-3');

			$steps.addClass('active-' + step);

		})
		.on('wpcf7mailsent', function(event){
			// redirect form after submit
			location = skwp.thanks_url;
		})
		// sdileni - email
		.on('click', '.share-email', function(e){
			var url = 'mailto:?subject=' + encodeURIComponent( skwp.message_product_email ) + '&body=' + encodeURIComponent( $(this).attr('data-share-url' ) );

			location.href = url;

			e.preventDefault();
		})
		// sdileni - facebook
		.on('click', '.share-facebook', function(e){
			var winTop = (screen.height / 2) - (350 / 2);
			var winLeft = (screen.width / 2) - (520 / 2);

			window.open('http://www.facebook.com/sharer.php?u=' + encodeURIComponent( $(this).attr('data-share-url') ), 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=520,height=350');

			e.preventDefault();
		})
		// sdileni - twitter
		.on('click', '.share-twitter', function(e){
			var winTop = (screen.height / 2) - (350 / 2);
			var winLeft = (screen.width / 2) - (520 / 2);

			window.open('http://twitter.com/share?text=' + encodeURIComponent( $(this).attr('data-share-title') ) + '&url=' + encodeURIComponent( $(this).attr('data-share-url') ) + '&hashtags=macpodpora', 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=520,height=350');

			e.preventDefault();
		})
		// woocommerce filtr - strankovani
		.on('click', '.woocommerce-pagination a', function(e){
			var href = $(this).attr('href');
			ajax_filter(href.replace(/^.*\/\/[^\/]+/, '')); // odstranime domenu z odkazu a nacteme filtr
			$('html, body').animate( { scrollTop: 0 }, 'slow' );
			e.preventDefault();
		})
		// tlacitko filtrovani - poskladani URL
		.on('change', '.f-filter input', function(e){
			var val = [];
			var min_price = 0;
			var max_price = 0;

			// cenovy rozsah
			if ( jQuery('.filter-price').length > 0 ) {
				min_price = jQuery('.f-filter input[name="min_price"]').val();
				max_price = jQuery('.f-filter input[name="max_price"]').val();
			}

			// checkboxy
			jQuery('.f-filter :checkbox:checked').each(function(i){
				var name = jQuery(this).attr('name').replace('[]', '');

				if ( typeof( val[name] ) == 'undefined' ) {
					val[name] = jQuery(this).val();
			    } else {
					val[name] = val[name] + ',' + jQuery(this).val();
			    }
			});

			// poskladame URL
			// STARA VERZE:
			/*
			let ret = [];
			for ( let d in val )
				ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(val[d]));

			// odstranime pripadne strankovani z URL adresy
			var path_name = location.pathname;

			if ( path_name.indexOf( '/page/' ) > -1 ) {
				path_name = path_name.split( '/' );
				path_name.splice( -3, 3 ); // odstranime /page/N/ z adresy
				path_name = path_name.join( '/' ) + '/';
			}

			// nacteme pres ajax
			ajax_filter( path_name + '?' + ret.join('&') );
			*/

			/*
			NOVA VERZE: - MUSIM ZAKOMENTOVAT KVULI UPDATU PRODUKCE */
			let ret = [];
			for ( let d in val ) {
				var set_val = d.replace( 'filter_', '' );
				set_val = set_val.replace( 'velikost-uloziste', 'hdd' );

				ret.push( encodeURIComponent( set_val ) + '-' + val[d] );
			}

			var path_name = location.pathname;
			if ( path_name.indexOf( '/kategorie-produktu/' ) > -1 ) {
				var p_name_parse = path_name.replace( '/kategorie-produktu/', '' ).split( '/' );
				path_name = '/kategorie-produktu/' + p_name_parse[0];

				/*
				if ( location.pathname.indexOf( '/page/' ) > -1 ) {
					path_name += '/page/' + p_name_parse[2];
				}
				*/
			} else if ( path_name.indexOf( '/obchod/' ) > -1 ) {
				var p_name_parse = path_name.replace( '/obchod/', '' );
				path_name = '/obchod/' + p_name_parse;

				/*
				if ( location.pathname.indexOf( '/page/' ) > -1 ) {
					path_name += '/page/' + p_name_parse[1];
				}
				*/
			}

			if ( location.pathname.indexOf( '/page/' ) > -1 ) {
				var page_parse = location.pathname.split( '/' );
				console.log(page_parse);return;
				path_name.splice( -3, 3 ); // odstranime /page/N/ z adresy
				path_name = path_name.join( '/' ) + '/';
			}

			// nacteme pres ajax
			var final_uri = path_name + '/' + ret.join('+');
			final_uri = final_uri.replace( '//', '/' );

			if ( min_price > 0 || max_price > 0 ) {
				final_uri += '?cena=' + min_price + '-' + max_price;
			}

			ajax_filter( final_uri );

			// prevent default
			e.preventDefault();
		})
		// woo js filter
		.on('click', '.woo-js-filter', function(e) {
			ajax_filter( $(this).attr('href') );
			e.preventDefault();
		})
		// cenik oprav - otevreni submenu
		.on('click', '.open-sub-devices', function(e) {

			var $this = $(this),
				open = $(this).data('open'),
				$brands = $('.brands').find('li');

			$brands.removeClass('is-active');
			$this.closest('li').addClass('is-active');

			$('.devices-parent').addClass('hide');
			$('.devices-parent-' + open).removeClass('hide');

			e.preventDefault();
		})
		// fake list select
		.on('click', '.js-select-show', function(e){
			var $this = $(this),
				$parent = $this.closest('.select-list');

			$('.select-list').not($parent).removeClass('select-list--open');
			$parent.toggleClass('select-list--open');
		})
		// fake list select - close on click everywhere
		.on('click', 'body', function(e){

			if ( $(e.target).closest('.select-list--open').length === 0) {
				$('.select-list').removeClass('select-list--open');
			}

		})
		// catdesc
		.on( 'click', '.catdesc-click', function( e ) {
			var el = $( this ).parent();
			el.find( '.b-catdesc__text' ).removeClass( 'catdesc-click' ).removeClass( 'inactive' );
			el.find( '.b-catdesc__btn' ).hide();
			e.preventDefault();
		} )
		// fancybox formulare
		.ready( function() {
			$('a[href^="#form-"]').addClass('fancybox');
			$('a[href^="#fancybox-"]').addClass('fancybox');

			// fancybox youtube videa
			Fancybox.bind('.fancybox-youtube', {
				fitToView   : false,
				width       : '70%',
				height      : '70%',
				autoSize    : false,
				closeClick  : true,
				openEffect  : 'none',
				closeEffect : 'none'
			});

			// udalost popstate v kosiku
			if ( $( 'body' ).hasClass( 'woocommerce-cart' ) ) {
				window.addEventListener( 'popstate', function( e ) {
					var get_step = getQueryVariable( 'step' );
					active_cart_step = ( get_step === false ? 1 : get_step );
					cart_loading();
					cart_reload( true );
				});

				posta_autocomplete();
			}
		});

		$('.radio__toggle').trigger('change');
		$('.checkbox__toggle').trigger('change');

		$('.f-newsletter')
			.on('submit', function(event){
				event.preventDefault()

				var $form = $(this);
				var $email = $form.find('.inp__text');

				if ( $email.val() == '' ) {
					$email.addClass('wpcf7-not-valid');
				} else {
					$email.removeClass('wpcf7-not-valid');

					$.ajax({
						url: skwp.ajax_url,
						type: 'post',
						data: {
							action: 'add_to_newsletter',
							email: $email.val(),
						},
						success: function(result) {
							if ( result.status ) {
								$form.closest('.b-newsletter__inner').append('<p class="message message--small message--ok">' + result.output + '</p>');
								$form.hide();
							} else {
								$email.addClass('wpcf7-not-valid').val(result.output);
							}
						}
					});
				}
			});

		function cart_reload(scroll_top) {
			$.ajax({
			    url: wc_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'get_basket' ),
			    type: 'post',
			    dataType: 'HTML',
			    data: {
					step: active_cart_step
			    },
			    beforeSend: function(){

			    }
			})
			.done(function(response){
			    //if ( active_cart_step == 2 ) {
			    //	cart_load_payments(response);
			    //} else {
			    	$('.woocommerce').css('opacity', '').html(response);
			    	posta_autocomplete();
			    //}

			    if ( scroll_top ) {
			    	$( 'html, body' ).animate( { scrollTop: 0 }, 'slow' );
			    }
			});
		}

		function cart_reloaded(scroll_top, response) {
			//if ( active_cart_step == 2 ) {
		    //	cart_load_payments(response);
		    //} else {
		    	$('.woocommerce').css('opacity', '').html(response);
		    	posta_autocomplete();
		    //}

		    if ( scroll_top ) {
		    	$( 'html, body' ).animate( { scrollTop: 0 }, 'slow' );
		    }
		}

		function cart_load_payments(html_response) {
			cart_loading();

			jQuery.ajax( {
				type: 'post',
				url: wc_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'get_payments' ),
				dataType: 'html'
			}).done( function( response ) {
				$('.woocommerce').css('opacity', '').html(html_response);
				$('#payments').html(response);
				$('.b-loading').removeClass('is-active');
				posta_autocomplete();
			} );
		}

		function cart_loading() {
			$('.b-loading').addClass('is-active');
		}

		function change_step(goto_step) {
			// pokud je krok s vyberem dopravy, zkontrolujeme, jestli ma uzivatel vybranou pobocku posty
			if ( goto_step != 1 && active_cart_step == 2 && typeof posta_must_select != 'undefined' ) {
				if ( $('#posta').val() == '' ) {
					cart_error( skwp.choose_post_text );
					return;
				}
			}

			// presuneme se na dalsi krok, zmenime address bar
			active_cart_step = goto_step;

			if ( history.pushState ) {
				var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?step=' + active_cart_step;
				window.history.pushState( { path: newurl }, '', newurl );
			}

			cart_loading();
			cart_reload(true);
		}

		function cart_save_address_and_finish() {

			// Check terms
			var terms = 0;
			if ( $('#terms').is(':checked') ) {
				terms = 1;
			}

			$.ajax({
			    url: skwp.ajax_url,
			    type: 'post',
			    data: {
			        action: 'woocommerce_save_address',
					step: active_cart_step,
					data: $('.address-form').serialize() + '&terms=' + terms
			    },
			    beforeSend: function(){
			    	cart_loading();
			    }
			})
			.done(function(response){
			    if ( response.status ) {
			    	location.href = '?send_order';
			    } else {
			    	if ( typeof response.errors != 'undefined' ) {
			    		var text = '';

			    		for ( var i = 0; i < response.errors.length; i++ ) {
			    			text += response.errors[i].message + '<br>';
			    		}

			    		cart_error( text );
			    	} else {
			    		cart_error( response.status_message );
			    	}

			    	$('.b-loading').removeClass('is-active');
			    }
			});
		}

		function cart_error( message ) {
			var html = '<ul class="woocommerce-error"><li>' + message + '</li></ul>';
			$('#cart-error div').html( html );
			$('#cart-error').slideDown('fast');
			$('html, body').animate( { scrollTop: 0 }, 'slow' );
		}

		function getQueryVariable( variable ) {
			var query = window.location.search.substring( 1 );
			var vars = query.split( '&' );

			for ( var i = 0; i < vars.length; i++ ) {
				var pair = vars[i].split( '=' );

				if( pair[0] == variable ) {
					return pair[1];
				}
			}

			return false;
		}

		function posta_autocomplete() {
			var options = {
				url: function(phrase) {
					return skwp.ajax_url;
				},
				getValue: function(element) {
					return element.name;
				},
				ajaxSettings: {
					dataType: 'json',
					method: 'POST',
					data: {
						dataType: 'json'
					}
				},
				preparePostData: function(data) {
					data.phrase = $('#posta').val();
					data.action = 'woocommerce_posty';
					return data;
				},
				requestDelay: 400,
				list: {
					onChooseEvent: function() {
						$.ajax( {
							type: 'post',
							url: wc_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'update_shipping' ),
							data: {
								set_post: $( '#posta' ).getSelectedItemData().id,
								step: 2
							},
							beforeSend: function(){
								cart_loading();
							},
						}).done( function( response ) {
							$('.woocommerce').html(response.cart);
							$('#payments').html(response.payments);
							$('.b-loading').removeClass('is-active');
						} );
					}
				}
			};
			$('#posta').easyAutocomplete(options);
		}

		function ajax_filter( url ) {
			// loading
			$('.b-loading').addClass('is-active');

			// zmenime URL bez obnoveni stranky
			if ( history.pushState ) {
				window.history.pushState( '', document.title, url );
			}

			// nacteme stranku
			$.ajax( {
				type: 'post',
				url: url,
				dataType: 'html',

			}).done( function( response ) {
				$('#main').html(response);

				var c = require('./multislider');
				c.init( $(document) );

				$('.b-loading').removeClass('is-active');
			} );
		}

		function cart_count() {
			// pocet polozek v kosiku
			$.get( '/?wc-ajax=cart_count&random=' + Math.random(), function( data ) {
				if ( data == '0' || data == '' ) {
					$('.cart-count').addClass('hide');
				} else {
					$('.cart-count').html(data).removeClass('hide');
				}
			} );
		}

		function insertParam(key, value) {
		    key = encodeURI(key); value = encodeURI(value);

		    var kvp = document.location.search.substr(1).split('&');

		    var i=kvp.length; var x; while(i--)
		    {
		        x = kvp[i].split('=');

		        if (x[0]==key)
		        {
		            x[1] = value;
		            kvp[i] = x.join('=');
		            break;
		        }
		    }

		    if(i<0) {kvp[kvp.length] = [key,value].join('=');}

		    //this will reload the page, it's likely better to store this until finished
		    return kvp.join('&');
		}

		cart_count();
};

exports.init = eventActions;



// WEBPACK FOOTER //
// ./src/js/components/eventActions.js